module.exports = __webpack_public_path__ + "img/antes_despues_120.96ef8a45.png";